// React
import { DetailedHTMLProps, InputHTMLAttributes, forwardRef } from "react"

interface Type
  extends DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  error?: string
  withOutErrorMessage?: boolean
  label?: string
  type?: string
  className?: string
  inputClass?: string
  textRight?: boolean
  textWhite?: boolean
}

export const Input = forwardRef<HTMLInputElement, Type>((props, ref) => {
  const {
    error,
    withOutErrorMessage,
    label,
    className,
    inputClass,
    textRight,
    textWhite,
    type,
    placeholder,
    disabled,
    ...inputProps
  } = props

  const inputId = inputProps.id ?? inputProps.name?.toString()

  return (
    <div className={`form-control ${className ?? ""}`}>
      {label && (
        <label className="label" htmlFor={inputId}>
          <span
            className={`label-text font-bold ${textWhite && "!text-[#cacccb]"} ${error && "text-error"}`}
          >
            {label}
          </span>
        </label>
      )}

      <input
        {...inputProps}
        ref={ref}
        id={inputId}
        type={type}
        disabled={disabled}
        placeholder={disabled ? "-" : placeholder}
        className={`input input-bordered dark:border-gray-400 ${inputClass ?? ""} ${error && "!input-error"} ${textRight ? "text-right" : ""}`}
      />

      {error && !withOutErrorMessage && (
        <div className="pt-1 min-h-0" role="alert">
          <span className="text-xs font-bold text-error">{error}</span>
        </div>
      )}
    </div>
  )
})

Input.displayName = "Input"
